<enhanced-help componentName="notes" [compact]="true"></enhanced-help>
<div class="container-with-footer">
    <div class="contents">
        <div
            *ngIf="equipment.notes"
            class="pre-wrap"
            [innerHtml]="equipment.notes | autolink"
        ></div>
        <empty
            *ngIf="!equipment.notes && canEdit"
            componentName="notes-empty-edit"
        ></empty>
        <empty
            *ngIf="!equipment.notes && !canEdit"
            componentName="notes-empty"
        ></empty>
    </div>
    <div class="action-container">
        <button
            *ngIf="hasEdit"
            [disabled]="!canEdit || working"
            class="btn btn-primary"
            type="button"
            (click)="editNotes()"
        >
            Edit
        </button>
    </div>
</div>
